import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { LinkText } from 'ilenia';
import { BusinessUnit } from '../../Model';

interface AccessErrorProps {
    businessUnit: BusinessUnit;
}

interface LinkErrorProps {
    text: string;
    link: string;
}

export const AccessError: React.FunctionComponent<AccessErrorProps> = ({ businessUnit }) => {
    return (
        <div className={css(styles.text, styles.textAfter)}>
            <LinkText
                id="login.accessError"
                interpolations={{
                    businessUnit: `${businessUnit.displayName} (${businessUnit.name?.identifying})`,
                }}
                links={[{href: 'https://support.trustpilot.com/hc/en-us/requests/new?ticket_form_id=360000901820', target: '_blank' }]}
            />
            </div>
    );
};

export const LinkError: React.FunctionComponent<LinkErrorProps> = ({ text, link }) => {
    return (
        <div className={css(styles.text, styles.textAfter)}>
            <LinkText id={text} links={[{href: link, target: '_blank' }]} />
        </div>
    );
};

const styles = StyleSheet.create({
    text: {
        backgroundColor: 'rgb(251, 209, 204)',
        color: 'rgb(27, 27, 33)',
        lineHeight: '1.6',
        overflow: 'hidden',
        padding: '16px',
        border: 'medium none',
        borderRadius: '2px',
        marginTop: '24px',
    },
    textAfter: {
        ':first-child + div': {
            marginTop: '0',
            paddingTop: '0',
        },
    },
});
